var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0406 14.1969C19.6281 14.1969 19.25 14.5406 19.25 14.9875V18.0469C19.25 18.3562 19.0094 18.5969 18.7 18.5969H2.13125C1.82187 18.5969 1.58125 18.3562 1.58125 18.0469V14.9875C1.58125 14.5406 1.20312 14.1969 0.790625 14.1969C0.378125 14.1969 0 14.5406 0 14.9875V18.0469C0 19.2156 0.928125 20.1437 2.09688 20.1437H18.7C19.8687 20.1437 20.7969 19.2156 20.7969 18.0469V14.9875C20.8312 14.5406 20.4531 14.1969 20.0406 14.1969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86557 15.0562C10.0031 15.1937 10.2093 15.2625 10.4156 15.2625C10.6218 15.2625 10.7937 15.1937 10.9656 15.0562L15.9499 10.2094C16.2593 9.9 16.2593 9.41875 15.9499 9.10938C15.6406 8.8 15.1593 8.8 14.8499 9.10938L11.2062 12.6844V0.790625C11.2062 0.378125 10.8624 0 10.4156 0C10.0031 0 9.62495 0.34375 9.62495 0.790625V12.6844L5.9812 9.10938C5.67182 8.8 5.19057 8.83438 4.8812 9.10938C4.57182 9.41875 4.6062 9.9 4.8812 10.2094L9.86557 15.0562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d9f537d58f529351d7e779b69c9db3de.svg";
export { ForwardRef as ReactComponent };